export default function Tester({
  element,
  func
}) {
  return func(element);
}